// extracted by mini-css-extract-plugin
export default {"home":"home_home__pIUsu","card":"home_card__ST1O6","left":"home_left__vTjaE","right":"home_right__L+0O8","buynow":"home_buynow__7gGex","buynowbtn":"home_buynowbtn__qnS2J"};